import React, { useContext, useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { apiRoutes } from '../../../AppSettings';
import { AuthContext } from '../../../contexts/AuthContext';
import axios from 'axios';
import Util from '../../../Util';
import alertify from 'alertifyjs';
import PatientAvatar from './PatientAvatar';
import DoctorAvatar from './DoctorAvatar';

const customStyles = {
    title: {
        style: {
            fontSize: '12px', // override the row height
        }
    },
    rows: {
        style: {
            fontSize: '12px', // override the row height
        }
    },
    headCells: {
      style: {
        paddingLeft: '15px', // override the cell padding for head cells
        paddingRight: '15px',
        fontWeight: 'bold',
        fontSize: '15px'
      },
    },
    cells: {
      style: {
        paddingLeft: '15px', // override the cell padding for data cells
        paddingRight: '15px',
        paddingTop: '10px', // override the cell padding for data cells
        paddingBottom: '8px',
        fontSize: '15px',
      },
    },
  };



const AppoinmentList = () => {
    const { userState } = useContext(AuthContext);
    const [data, setData] = useState([]);

    const options = {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'bearer ' + userState.token
        }
    };

    useEffect(() => {
        loadGrid();
    }, []);

    const loadGrid =() => {
        axios.get(apiRoutes.GetAllAppoinments, options)
            .then((response) => {
                if (response.status === 200) {
                    const data = response.data;
                    setData(data);
                }
        }, (error) => {
            console.log(error);
        });
    }

    const columns = [
        {
            name: '#Appoinment',
            selector: 'appoinmentNumber',
            sortable: true,
            width: '200px'
        },
        {
            name: 'Doctor Name',
            selector: 'firstName',
            sortable: true,
            width: '250px',
            cell: row => <DoctorAvatar doctor={row.doctor} />
        },
        {
            name: 'Speciality',
            selector: 'category',
            sortable: true,
            width: '120px',
            cell: row => <div>{row.doctor.category}</div>
        },
        {
            name: 'Patient Name',
            selector: 'patientName',
            sortable: true,
            width: '250px',
            cell: row => <PatientAvatar patient = {row.patient} /> 
        },
        {
            name: 'Apointment Time',
            selector: 'appoinmentTime',
            sortable: true,
            width: '190px',
            cell: row => <div>{
                            new Intl.DateTimeFormat("en-GB", {
                            year: "numeric",
                            month: "short",
                            day: "2-digit"
                            }).format(new Date(row.appoinmentDate+".000Z"))
                        }<span className="text-primary d-block">{row.appoinmentTime}</span></div>
        },
        {
            name: 'Status',
            selector: 'status',
            sortable: true,
            width: '50px',
            cell: row => <div className="status-toggle">
                            <input type="checkbox" id={"status_" + row.doctorId} className="check" checked={row.isActive} onChange={e => handleChange(row.appoinmentId, row.isActive)} />
                            <label htmlFor={"status_" + row.doctorId} className="checktoggle">checkbox</label>
                        </div>
        },
        {
            name: 'Amount',
            selector: 'totalAmount',
            sortable: true,
            right: true,
            width: '150px',
            cell: row => <div>${row.invoices.reduce((a, b) => a + (b.totalAmount || 0), 0)} </div>
        }
    ];

    
    const handleChange = (id, isActive) => {
        alertify.confirm("Warning!", `Are you sure want to ${ isActive ? 'disable' : ' enable' }?`,
        function(){
            axios.post(apiRoutes.ToggleAppoinment, JSON.stringify({id: id}), options)
            .then((response) => {
                alertify.success(`Appoinment ${ isActive ? 'disabled' : ' enabled' } successfully`);
                loadGrid();
            }, (error) => {
                console.log(error);
            });
        },
        function(){
        
        });
    };


    return (  
        <div>
            <DataTable
                title="Appoinments List"
                columns={columns}
                data={data}
                customStyles={customStyles}
                pagination
                highlightOnHover={true}
            />
        </div>
    );
}
 
export default AppoinmentList;